export interface IStoreType {
  id: number;
  name: string;
  groupName: string;
  readonly modifiedDateTime: Date;
  readonly cid: number;
  orderIndex: number;
  readonly modifiedDateTimeFriendly: string;
  iconName: string;
  imagePath: string;
  hexColor: string;
  value: number;
  type: string;
  displayColorPicker?: false;
}

export class StoreType implements IStoreType {
  public readonly id = -1;
  public name = "";
  public groupName = "";
  public readonly modifiedDateTime = new Date();
  public readonly cid = 0;
  public orderIndex = 0;
  public readonly modifiedDateTimeFriendly = "";
  public iconName = "";
  public imagePath = "";
  public hexColor = "";
  public value = 0;
  public displayColorPicker?: false;
  public type = "";
}
